import React from "react";
import {
    Heading,
    Puffs
} from "arwes"

class ErrorBoundary extends React.Component {
    constructor() {
        super();

        this.state ={
            hasError: false
        };
    }

    static getDerivedStateFromError(error){

        return {
            hasError: true
        }
    }

    componentDidMount(error, info) {
        console.log(error)
    }

    render()
    {
        if(this.state.hasError){
            return(
                <div className="text-center col-md-12 col-xs-12 col-lg-12">
                    <Puffs>
                    <Heading>Sorry this Page is not available</Heading>
                    <img height="400" width="400" src="https://i.imgur.com/A040Lxr.png" alt="page broken"/>
                    <div style={{ height:300 }}></div>
                    </Puffs>
                </div>
            )

        }
        return this.props.children


    }
}

export default ErrorBoundary;